"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Avatar_1 = __importDefault(require("../../Avatar"));
var react_redux_1 = require("react-redux");
var userSlice_1 = require("../../../features/user/userSlice");
var Links_1 = __importDefault(require("../../Account/AccountDropdownBottomSheet/Links"));
var ArrowIcon_1 = __importDefault(require("./ArrowIcon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AccountDropDown = function (_a) {
    var closeMobileMenu = _a.closeMobileMenu;
    var user = react_redux_1.useSelector(userSlice_1.useSelectUser);
    var displayName = react_redux_1.useSelector(userSlice_1.selectDisplayName);
    var _b = react_1.useState(false), arrowIconActive = _b[0], changeArrowIconActive = _b[1];
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.account_dropdown },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.account_dropdown_head, onClick: function () { return changeArrowIconActive(!arrowIconActive); } },
            react_1.default.createElement(Avatar_1.default, { img: user === null || user === void 0 ? void 0 : user.avatar, name: user === null || user === void 0 ? void 0 : user.username }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.account_dropdown_head_info },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null, displayName),
                    react_1.default.createElement("div", null)),
                react_1.default.createElement("span", null, user === null || user === void 0 ? void 0 : user.email)),
            react_1.default.createElement(ArrowIcon_1.default, { active: arrowIconActive })),
        arrowIconActive && (react_1.default.createElement("div", { className: styles_module_scss_1.default.bottom_sheet_menu_section },
            react_1.default.createElement(Links_1.default, { onDismiss: closeMobileMenu })))));
};
exports.default = react_1.memo(AccountDropDown);
